import { normalizeGenres } from '../domain/genres.js';
import type { AlbumFilters } from '../types';

export function filtersFromSearch(search: string): Partial<AlbumFilters> {
  const params = new URLSearchParams(search);
  const filters: Partial<AlbumFilters> = {};
  if (params.has('q')) filters.query = params.get('q') || '';
  if (params.has('artist')) filters.artist = params.get('artist') || '';
  if (params.has('label')) filters.label = params.get('label') || '';
  filters.genres = normalizeGenres(params.getAll('genre').filter(Boolean));
  filters.formats = params.getAll('format').filter(Boolean);
  filters.qualities = params.getAll('quality').filter(Boolean);
  filters.decades = [...new Set(params.getAll('decade').filter((value) => /^\d{3}0$/.test(value)).map(Number))];
  return filters;
}

export function filtersToSearch(filters: AlbumFilters): string {
  const params = new URLSearchParams();
  if (filters.query) params.set('q', filters.query);
  if (filters.artist) params.set('artist', filters.artist);
  if (filters.label) params.set('label', filters.label);
  for (const value of filters.genres) params.append('genre', value);
  for (const value of filters.formats) params.append('format', value);
  for (const value of filters.qualities) params.append('quality', value);
  for (const value of filters.decades) params.append('decade', String(value));
  const query = params.toString();
  return query ? `?${query}` : '';
}

